import { render, staticRenderFns } from "./SimulationDetailPage.vue?vue&type=template&id=0e1974b9&scoped=true"
import script from "./SimulationDetailPage.vue?vue&type=script&lang=ts"
export * from "./SimulationDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./SimulationDetailPage.vue?vue&type=style&index=0&id=0e1974b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1974b9",
  null
  
)

export default component.exports